import { endPoints } from 'api/endpoints';
import axios from 'api/request';

/**
 * Generates a service account ID using the CMP API
 * @param {Object} params - Parameters for service account generation
 * @param {string} params.accountType - Account type (e.g., "active directory")
 * @param {string} params.applicationShortName - Application short name
 * @param {string} params.environment - Environment (e.g., "Development", "Production")
 * @returns {Promise<Object|null>} Generated service account response or null
 */
export const fetchServiceAccount = async ({ accountType, applicationShortName, environment }) => {
    // Validate required parameters
    if (!accountType || !applicationShortName || !environment) {
        return null;
    }

    try {
        const payload = {
            accountType,
            applicationShortName,
            environment,
        };

        const response = await axios.post(endPoints.serviceAccountCreation.Jwt.generateServiceAcc, payload);
        return response?.data || null;
    } catch (error) {
        return null;
    }
};

export default {
    fetchServiceAccount,
};
